const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/papaenmousse`;
const TOKEN_KEY = 'papaenmousse_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export async function api(path, { method = 'GET', body, auth = true } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth) headers.Authorization = `Bearer ${getToken()}`;
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = data?.detail;
    const msg = typeof detail === 'string' ? detail : 'Une erreur est survenue';
    throw new Error(msg);
  }
  return data;
}

// Laissez-passer : échange le jeton panel contre un jeton admin CRM (outil Mail)
export async function getMailToken() {
  return api('/mail-token', { method: 'POST' });
}
